import React, { SVGProps, FC } from 'react';

export const Picture: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={138}
    height={132}
    viewBox="0 0 107 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#picture_svg__a)">
      <g clipPath="url(#picture_svg__b)">
        <circle
          cx={19.791}
          cy={74.048}
          r={18.321}
          transform="rotate(-.454 19.791 74.048)"
          fill="#1DBF73"
          stroke="#1DBF73"
          strokeWidth={1.505}
          strokeMiterlimit={10}
        />
        <mask
          id="picture_svg__c"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={-5}
          y={38}
          width={58}
          height={63}
        >
          <path
            d="M8.097 57.363c8.505 4.696 26.129 24.668 26.129 24.668s3.623-15.933 3.732-19.806a32.537 32.537 0 0 1 3.316-13.74c2.372-4.495 3.438-8.472 4.83-8.839 1.391-.366 2.838 3.67-.116 12.474l3.296-6.727 2.747 12.68-1.037 2.655"
            stroke="#222325"
            strokeWidth={1.379}
            strokeMiterlimit={10}
          />
          <path
            d="m51.403 59.667-.861 1.978-2.26 27.845a11.539 11.539 0 0 1-2.191 5.892 11.467 11.467 0 0 1-4.951 3.853c-8.951 2.868-26.068-9.918-32.4-16.156L-3.43 72.274"
            stroke="#222325"
            strokeWidth={1.379}
            strokeMiterlimit={10}
          />
          <path
            d="M31.66 79.864 19.482 91.675-4.492 71.753 7.843 57.595l4.755 3.508 4.761 4.1 14.3 14.661Z"
            fill="#222325"
          />
          <path
            d="M41.245 99.441c-8.028 2.181-18.922-5.672-23.366-9.87l10.48-13.315 5.867 5.775 3.566-17.494-.033-4.233c-.007-.847 1.364-6.01 2.05-8.485l3.12-6.905c.514-1.945 1.966-5.732 3.663-5.322 1.697.41.763 7.227.084 10.585l2.608-4.784 2.747 12.68-1.562 3.188.02 2.646-2.427 27.541c-.338 1.944-2.174 6.263-6.817 7.993Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#picture_svg__c)">
          <circle
            cx={19.873}
            cy={74.206}
            r={18.524}
            transform="rotate(-.454 19.873 74.206)"
            fill="#222325"
            stroke="#222325"
            strokeWidth={1.505}
            strokeMiterlimit={10}
          />
          <path
            d="M41.245 99.441c-8.028 2.181-18.922-5.672-23.366-9.87l10.48-13.315 5.867 5.775 3.566-17.494-.033-4.233c-.007-.847 1.364-6.01 2.05-8.485l3.12-6.905c.514-1.945 1.966-5.732 3.663-5.322 1.697.41.763 7.227.084 10.585l2.608-4.784 2.747 12.68-1.562 3.188.02 2.646-2.427 27.541c-.338 1.944-2.174 6.263-6.817 7.993Z"
            fill="#fff"
          />
          <path
            d="m51.402 59.667-.86 1.977-2.26 27.845a11.539 11.539 0 0 1-2.192 5.892 11.468 11.468 0 0 1-4.95 3.853c-8.952 2.868-25.54-9.388-31.871-15.626l-7.939-7.41"
            stroke="#222325"
            strokeWidth={1.379}
            strokeMiterlimit={10}
          />
          <path
            d="m50.993 60.729 1.037-2.655-2.747-12.68-3.296 6.727c2.954-8.805 1.508-12.84.116-12.474-1.392.366-2.458 4.343-4.83 8.837a32.537 32.537 0 0 0-3.315 13.741c-.11 3.873-3.733 19.807-3.733 19.807-3.74-4.38-12.177-13.876-16.01-16.81"
            stroke="#222325"
            strokeWidth={1.379}
            strokeMiterlimit={10}
          />
        </g>
      </g>
      <rect
        x={42.988}
        y={28.481}
        width={44.5}
        height={52.5}
        rx={1.25}
        transform="rotate(-11.07 42.988 28.48)"
        fill="#fff"
        stroke="#222325"
        strokeWidth={1.5}
      />
      <path
        d="M78.498 30 51 35.38M70.921 37.44 52.59 41.027M72.332 43l-18.331 3.587M82.497 46 55 51.38"
        stroke="#222325"
        strokeWidth={1.5}
      />
      <path
        d="m74.756 89.424-.099-20.304 7.875-1.417 6.932 18.757-8.488-4.823-6.22 7.787Z"
        fill="#20BB73"
        stroke="#20BB73"
        strokeWidth={1.5}
        strokeMiterlimit={10}
      />
      <path
        d="M68.273 64.577c.246.378.617.657 1.046.785.267.079.514.217.723.404a1.913 1.913 0 0 1 .42 2.303 1.913 1.913 0 0 0 .517 2.409l1.502 1.165c.357.277.799.416 1.246.393.446-.024.868-.21 1.19-.523a1.84 1.84 0 0 1 2.299-.206c.234.154.431.359.578.6.234.386.597.676 1.022.817.424.14.883.124 1.294-.048l1.734-.727c.41-.172.746-.487.945-.89.199-.402.249-.864.14-1.303a1.914 1.914 0 0 1-.02-.838c.056-.277.173-.537.341-.76a1.846 1.846 0 0 1 1.434-.737c.445-.01.871-.18 1.2-.48.33-.3.541-.712.597-1.159l.22-1.887a1.923 1.923 0 0 0-.296-1.281 1.894 1.894 0 0 0-1.046-.785 1.882 1.882 0 0 1-.72-.409 1.915 1.915 0 0 1-.409-2.304 1.915 1.915 0 0 0-.517-2.409l-1.505-1.166a1.863 1.863 0 0 0-1.245-.393c-.447.025-.87.211-1.189.525a1.838 1.838 0 0 1-2.3.207 1.906 1.906 0 0 1-.578-.6 1.896 1.896 0 0 0-1.021-.817 1.844 1.844 0 0 0-1.295.048l-1.734.726a1.85 1.85 0 0 0-.946.89c-.199.402-.248.864-.14 1.303a1.884 1.884 0 0 1-.322 1.598 1.85 1.85 0 0 1-1.432.738c-.446.009-.871.179-1.201.48-.33.3-.541.711-.596 1.158l-.233 1.892c-.055.447.05.902.297 1.28Z"
        fill="#fff"
        stroke="#222325"
        strokeWidth={1.274}
        strokeMiterlimit={10}
      />
      <path
        d="M42.068 47.153c-2.097 4.277-2.482 3.573-2.568 8.346l8-7.499c2.954-8.804.789-10.05-.602-9.684-1.392.366-2.459 4.343-4.83 8.837Z"
        fill="#fff"
      />
      <path
        d="M38 62c.086-4.774.97-8.57 3.067-12.846 2.372-4.494 3.438-8.472 4.83-8.838 1.391-.366 2.838 3.67-.116 12.474"
        stroke="#222325"
        strokeWidth={1.379}
        strokeMiterlimit={10}
      />
      <path
        d="m93.852 3.34-5.062 9.067M87.67 5.084l7.686 5.828M96.047 6.45 85.951 9.203"
        stroke="#232426"
        strokeWidth={1.065}
        strokeMiterlimit={10}
      />
      <path
        d="m38.041 31.21-11.04-4.556M46.632 21.918 42.121 11M39.494 23.409 30 16.378"
        stroke="#1DBF73"
        strokeWidth={1.5}
        strokeMiterlimit={10}
      />
      <circle cx={77.5} cy={63.5} r={3.5} fill="#1DBF73" />
    </g>
    <defs>
      <clipPath id="picture_svg__a">
        <path
          fill="#fff"
          transform="matrix(-1 0 0 1 107 0)"
          d="M0 0h107v102H0z"
        />
      </clipPath>
      <clipPath id="picture_svg__b">
        <path
          fill="#fff"
          transform="scale(-1 1) rotate(.454 -4704.85 -8931.21)"
          d="M0 0h70.919v68.555H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
